<template>
  <BAsyncAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Участник"
    no-data-text="Участник не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from '../BAutocompleteCommon/mixins'
import { ParticipantsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'
import BAsyncAutocomplete from '@/components/forms/BAsyncAutocomplete.vue'

export default {
  name: 'BAutocompleteParticipants',
  components: {
    BAsyncAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new ParticipantsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(params, ...args) {
      const { model } = this
      return this.adapter.getAll({ ...params, model }, ...args)
    },
  },
}
</script>
